import * as React from "react";
import MuiFormControl, {
    FormControlProps as MuiFormControlProps,
    FormControlClassKey as MuiFormControlClassKey
} from "@material-ui/core/FormControl";

export type FormControlClassKey = MuiFormControlClassKey;

export interface FormControlProps extends MuiFormControlProps { }

class FormControl extends React.PureComponent<FormControlProps> {
    render() {
        const { ...props } = this.props;
        return <MuiFormControl {...props}>
            {this.props.children}
        </MuiFormControl>;
    }
}

export default FormControl; 